// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { Resources } from "../../Commons/properties/Resources.js"
import { CreateMapByObj } from "../CreateMapByObjectUtils.js"
import { OrderType } from "./OrderType.js"

export const OrderTif =
{
    Day: 1,
    GTC: 2,
    IOC: 3,
    GTD: 4,
    FOK: 5,
    OnOpen: 6,
    OnClose: 7,
    GTS: 9
}

//для мапинга ключей локализации
export const OrderTifMap = CreateMapByObj(OrderTif)

export let TIF = function (type, expirationTime)
{
    this.type = type
    this.expirationTime = expirationTime
}

TIF.expireTimeTIF_Market = new Date();
TIF.expireTimeTIF_Limit = new Date();
TIF.expireTimeTIF_Stop = new Date();

TIF.handleNewExpireTime = function (date)
{
    if (!date) return;

    var now = new Date();
    return date >= now ? date : now;
};

TIF.getDefaultExpireTimeForOrderType = function (ordType, instrument)
{
    var date = null;

    switch (ordType)
    {
        case OrderType.Market:
            date = TIF.expireTimeTIF_Market;
            break;

        case OrderType.Limit:
        case OrderType.StopLimit:
            date = TIF.expireTimeTIF_Limit;
            break;

        case OrderType.Stop:
        case OrderType.TrailingStop:
            date = TIF.expireTimeTIF_Stop;
            break;
    }

    if (date &&
        instrument &&
        instrument.isFuturesSymbol &&
        instrument.lastTradeDate < date)
        date = instrument.lastTradeDate;

    return date || new Date();
};

TIF.createVariantsForTifs = function (array)
{
    var res = [];
    var len = array.length;
    for (var i = 0; i < len; i++)
    {
        var val = array[i];
        res.push({
            value: +val,
            text: Resources.getResource(OrderTifMap[val])
        });
    }
    return res;
};